import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchReportCategoriesDictionaryRequest = () => ({
  type: actionTypes.FETCH_REPORT_CATEGORIES_DICTIONARY_REQUEST,
});

export const fetchReportCategoriesDictionarySuccess = (categories) => ({
  type: actionTypes.FETCH_REPORT_CATEGORIES_DICTIONARY_SUCCESS,
  categories,
});

export const fetchReportCategoriesDictionaryFailure = () => ({
  type: actionTypes.FETCH_REPORT_CATEGORIES_DICTIONARY_FAILURE,
});

export const fetchReportCategoriesDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchReportCategoriesDictionaryRequest());

    const categories = await api.fetchReportCategoriesDictionary({ locale });
    dispatch(fetchReportCategoriesDictionarySuccess(categories));
  } catch (error) {
    console.error('REPORT_CATEGORIES_DICTIONARY', error);
    dispatch(fetchReportCategoriesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/report-categories-dictionary.actions.js